import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { useState, useMemo, useCallback, useEffect } from "react";
import { ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("candidate");
      window.location.replace("/");
    }
    return Promise.reject(error);
  },
);

const Index = () => {
  const { yviAntTheme, muiTheme } = useUiManagement();
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <ConfigProvider theme={yviAntTheme}>
            <App />
          </ConfigProvider>
        </HelmetProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </React.StrictMode>
  );
};

root.render(<Index />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const useUiManagement = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const handleDarkMode = useCallback((flag) => setIsDarkMode(flag), []);
  useEffect(() => {
    if (isDarkMode) {
      document.getElementsByTagName("html")[0].classList.remove("light");
      document.getElementsByTagName("html")[0].classList.add("dark");
    } else {
      document.getElementsByTagName("html")[0].classList.remove("dark");
      document.getElementsByTagName("html")[0].classList.add("light");
    }
  }, [isDarkMode]);
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const yviAntTheme = useMemo(() => {
    return {
      token: {
        fontFamily: '"Poppins", sans-serif',
        colorPrimary: "#0A7F8F",
      },
      components: {
        Tabs: {
          inkBarColor: "#fff",
          itemHoverColor: "red",
          itemSelectedColor: "red",
        },
      },
      algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
    };
  }, [isDarkMode, darkAlgorithm, defaultAlgorithm]);

  return {
    handleDarkMode,
    isDarkMode,
    yviAntTheme,
  };
};
